module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-38-28d3702ab5d13b2244df62aa978b7598.svg";